import React from 'react';
import {Link} from 'react-router-dom';

const Sidebar = ({user}) => {

  return (
    <div className="sidebar">
      <ul className="sidebar__list">
        {user.user_type == 2 && 
        <div>
          <li className="sidebar__list__item">
            <Link className="sidebar__list__item__link" to="/">
              <i className="fas fa-home"></i> Home
            </Link>
          </li>
          <li className="sidebar__list__item">
            <Link className="sidebar__list__item__link" to="/measurements">
              <i className="fas fa-pencil-alt"></i> Derving
            </Link>
          </li>
          <li className="sidebar__list__item">
            <Link className="sidebar__list__item__link" to="/dashboard">
              <i className="fas fa-chart-bar"></i> Dashboard
            </Link>
          </li>
          <li className="sidebar__list__item">
            <Link className="sidebar__list__item__link" to="/customers">
              <i className="fas fa-folder"></i> Klanten
            </Link>
          </li>
          <li className="sidebar__list__item">
            <Link className="sidebar__list__item__link" to="/customers/create">
              <i className="fas fa-user"></i> Nieuwe klant
            </Link>
          </li>
        </div>       
        }
        <li style={{position: 'absolute', bottom: '80px'}} className="sidebar__list__item">
          <Link className="sidebar__list__item__link" to="/logout">
            <i className="fas fa-arrow-right"></i> Uitloggen
          </Link>
        </li>
      </ul>
    </div>
  );

} 

export default Sidebar